"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Tag.scss");
var key_press_1 = require("../../../../../utils/key-press");
var Tag = function (_a) {
    var children = _a.children, _b = _a.events, events = _b === void 0 ? { onClick: function () { return null; } } : _b, _c = _a.options, options = _c === void 0 ? { type: "default" } : _c, hideFocus = _a.hideFocus, isLast = _a.isLast, setHideFocus = _a.setHideFocus, tagsType = _a.tagsType, testId = _a.testId, total = _a.total, overrideRemovableAccessibility = _a.overrideRemovableAccessibility;
    var _d = __read(React.useState({
        isRemoved: false,
        isSelected: options.defaultSelected ? options.defaultSelected : false,
    }), 2), state = _d[0], setState = _d[1];
    var isRemoved = state.isRemoved, isSelected = state.isSelected;
    var componentRef = React.createRef();
    var handleRemove = function () {
        if (testId && total) {
            var index = parseInt(testId.substring(testId.length - 1, testId.length), 10);
            if (total === index + 1) {
                var el = document.getElementById(testId.substring(0, testId.length - 1) + (index - 1));
                if (el) {
                    el.focus();
                }
            }
        }
    };
    var onClick = function () {
        if (options.type === "removable") {
            if (tagsType) {
                handleRemove();
            }
        }
        else if (options.selected === undefined) {
            setState(__assign(__assign({}, state), { isSelected: !isSelected }));
        }
        if (events.onClick) {
            events.onClick(options.type === "default"
                ? options.selected
                    ? options.selected
                    : isSelected
                : undefined);
        }
    };
    var onKeyDown = function (e) {
        if (setHideFocus) {
            setHideFocus(false);
        }
        if (options.type !== "disabled" && !isRemoved) {
            if (key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
                onClick();
            }
        }
    };
    var onKeyUp = function () {
        if (options.type !== "disabled" && !isRemoved) {
            if (setHideFocus) {
                setHideFocus(false);
            }
        }
    };
    return (React.createElement("div", { className: "" + styles.tagsCont + (" mar-b-xs " + (!isLast ? "mar-r-xs" : "")), "data-testid": testId },
        React.createElement("div", { className: "rel" },
            React.createElement("div", { "aria-checked": options.type !== "removable"
                    ? options.selected !== undefined
                        ? options.selected
                        : isSelected
                    : undefined, "aria-disabled": options.type === "disabled" ? true : undefined, className: "tag-button " + styles.tagsButton + " " + ((total && total < 1) ||
                    (options.type !== "disabled" &&
                        ((options.selected !== undefined ? options.selected : isSelected) ||
                            options.type === "removable"))
                    ? "bg-cobalt color-ui-white " + styles.tagsButtonSelected
                    : "bg-ui-white border-black " + styles.tagsButtonUnSelected) + (options.type === "disabled" ? " " + styles.tagsButtonDisabled : "") + (options.className ? " " + options.className : "") + (options.type === "removable" ? " " + styles.tagsButtonRemovable : "") + " border flex flex-1 flex-self-center flex-items-center font-medium justify-center rel type-xs mar-b-none", id: testId, ref: componentRef, role: tagsType === "default" ? "checkbox" : "button", onKeyDown: onKeyDown, onKeyUp: onKeyUp, onClick: onClick, tabIndex: 0 },
                children,
                options.type === "removable" ? (React.createElement("span", { className: "hidden-spoken" }, overrideRemovableAccessibility
                    ? overrideRemovableAccessibility
                    : " (press to remove)")) : null,
                options.type === "removable" ? React.createElement(CloseIcon, null) : null),
            !hideFocus && (React.createElement("span", { "aria-hidden": "true", className: "absolute hide " + styles.tagsButtonOutline })))));
};
var CloseIcon = function () { return (React.createElement("svg", { height: "14px", width: "14px", className: "mar-l-xxxs", style: { minHeight: 14, minWidth: 14 }, viewBox: "-18 32 36 36", "aria-hidden": "true", focusable: "false" },
    React.createElement("path", { fill: "#fff", d: "M-9.3 61.1c-.5 0-.9-.2-1.3-.5-.7-.7-.7-1.8 0-2.6L7.9 39.5c.7-.7 1.8-.7 2.6 0 .7.7.7 1.8 0 2.6L-8 60.5c-.4.4-.8.6-1.3.6zm18.5 0c-.5 0-.9-.2-1.3-.5l-18.5-18.5c-.7-.7-.7-1.8 0-2.6.7-.7 1.8-.7 2.6 0L10.5 58c.7.7.7 1.8 0 2.6-.4.3-.8.5-1.3.5z" }))); };
exports.default = Tag;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tags/components/Tag/Tag.js
// module id = 1788
// module chunks = 8